var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", { staticClass: "value" }, [
              _c("span", [_vm._v(_vm._s(_vm.settleProof.innerNo || "无"))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", { staticClass: "value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.tradeTypeMap[_vm.settleProof.tradeType]))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.settleProof.contractNo != null && _vm.settleProof.contractNo != ""
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("div", { staticClass: "value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.settleProof.contractNo))])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", { staticClass: "value" }, [
              _c("span", [_vm._v(_vm._s(_vm.settleProof.sellerRealComName))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", { staticClass: "value" }, [
              _c("span", [_vm._v(_vm._s(_vm.settleProof.sellerRealComCode))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", { staticClass: "value" }, [
              _c("span", [_vm._v(_vm._s(_vm.settleProof.buyerInnerSellerCode))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(6),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.settleBizTypeMap[_vm.settleProof.bizType]))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", { staticClass: "value" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    parseFloat(_vm.settleProof.settleAmount || 0).toFixed(2)
                  )
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.settleProof.paymentFinished
              ? _c("div", { staticClass: "value" }, [_vm._v("是")])
              : _c("div", { staticClass: "value" }, [_vm._v("否")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", { staticClass: "value" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    parseFloat(_vm.settleProof.appliedPayAmount || 0).toFixed(2)
                  )
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(10),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", { staticClass: "value" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    parseFloat(_vm.settleProof.paymentAmount || 0).toFixed(2)
                  )
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(11)
      ]),
      _vm._v(" "),
      _vm.settleProof.payPhaseFlag
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("付款阶段")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.settleProof.payPhaseFlag
        ? _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: {
                data: _vm.settleProof.settlePayPhases,
                border: "",
                "span-method": _vm.arraySpanMethod
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "phaseName",
                  label: "阶段名称",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "phaseType",
                  label: "阶段类型",
                  width: "150",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.payPhaseTypeMap[rows.row.phaseType])
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "acntPeriodStartDate",
                  label: "账期起算日",
                  width: "150",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _vm.settleProof.acntPeriodForm == 1
                ? _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "acntPeriodDays",
                      width: "150",
                      label: "账期"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.settleProof.acntPeriodForm == 2
                ? _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "phaseGapDays",
                      width: "150",
                      label: "当前阶段间隔天数"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "calcBasis",
                  label: "金额计算依据",
                  width: "150",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.amtCalcMethodMap[rows.row.calcBasis])
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "ratio",
                  label: "付款比例(%)",
                  width: "150",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "amount",
                  label: "付款金额",
                  width: "150",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "payMethod",
                  width: "150",
                  label: "付款方式"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.payMethodMap[rows.row.payMethod]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(12),
      _vm._v(" "),
      _vm.settleProof.settleChannelId == -1 &&
      _vm.settleProof.availableAmount > 0 &&
      !_vm.settleProof.paymentFinished &&
      (_vm.settleProof.pullBackNo == null || _vm.settleProof.pullBackNo == "")
        ? _c(
            "div",
            {
              staticClass: "form-toolbar",
              staticStyle: { "text-align": "left" }
            },
            [
              !_vm.settleProof.payPhaseFlag
                ? _c(
                    "button",
                    {
                      staticClass: "swb-btn swb-btn-small",
                      on: {
                        click: function($event) {
                          _vm.applyPayOption()
                        }
                      }
                    },
                    [_vm._v("申请付款")]
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.payVoucherList,
                border: "",
                maxHeight: "500",
                "tooltip-effect": "dark"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "no",
                  label: "付款单据号",
                  width: "160px;",
                  fixed: "",
                  align: "center",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payPhaseName",
                  label: "阶段名称",
                  width: "120px;",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "acntPeriodStartDate",
                  label: "账期起算日",
                  width: "120px;",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "outerNo",
                  label: "外部付款单据号",
                  width: "160px;",
                  align: "center",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "reservedPayNo",
                  label: "付款凭证号",
                  width: "160px;",
                  align: "center",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "staffLoan",
                  label: "员工借款",
                  width: "70px;",
                  align: "center",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.staffLoan
                          ? _c("span", { staticClass: "font-red" }, [
                              _vm._v("是")
                            ])
                          : _c("span", [_vm._v("否")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "subject",
                  label: "付款主题",
                  width: "120px;",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payWayText",
                  label: "付款途径",
                  width: "80px;",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payResultText",
                  label: "付款形式",
                  width: "80px;"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.payFormMap[rows.row.payForm]))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "payMethod", label: "付款方式", width: "80px;" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.payMethodMap[rows.row.payMethod]))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "amount",
                  label: "付款金额(元)",
                  width: "90px;",
                  align: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.prePayFlag
                          ? _c("span", [
                              _vm._v(
                                _vm._s((_vm.row.row.amountPre || 0).toFixed(2))
                              )
                            ])
                          : _c("span", [_vm._v(_vm._s(rows.row.amount))])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "auditStateText",
                  label: "审核状态",
                  width: "80px;",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payResultText",
                  label: "付款状态",
                  width: "80px;"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建日期",
                  width: "160px;",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.auditState == 0 && rows.row.applyState != 1
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.assignAuditor(rows.row)
                                  }
                                }
                              },
                              [_vm._v("指定审核岗")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        rows.row.applyState == 1 &&
                        rows.row.auditState != 1 &&
                        !rows.row.discarded &&
                        rows.row.auditorPostId ==
                          _vm.userInfo.scopeEntity.postId
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.doCheck(rows.row.id)
                                  }
                                }
                              },
                              [_vm._v("审核")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.viewPayInfo(rows.row.id)
                              }
                            }
                          },
                          [_vm._v("详情")]
                        ),
                        _vm._v(" "),
                        !rows.row.discarded && rows.row.payResult != 1
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.editBankAccInfo(rows.row)
                                  }
                                }
                              },
                              [_vm._v("补充银行卡")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-layout" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "page-size": _vm.pageSize,
              "page-sizes": _vm.pageSizes,
              "current-page": _vm.pageNumber,
              total: _vm.totalCount,
              layout: "total, sizes, prev, pager, next, jumper"
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.handleSizeChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("结算单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("交易类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("系统合同编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供方公司名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供方公司编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供方标识")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("结算金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否付款完成")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已申请金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已付款金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group center" }, [
      _c("div", { staticClass: "form-label" }, [_c("label")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("div", { staticClass: "value" }, [_c("span")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("付款单")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3028373a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3028373a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/settle/SettlePaymentInfo.vue
// module id = 2928
// module chunks = 0